module.exports = __webpack_public_path__ + "static/media/mg.eaf3b409.svg";